import { render, staticRenderFns } from "./ListagemModalDocumentos.vue?vue&type=template&id=2c9246be&scoped=true"
import script from "./ListagemModalDocumentos.vue?vue&type=script&lang=js"
export * from "./ListagemModalDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9246be",
  null
  
)

export default component.exports